import _slicedToArray from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import React from "react";
import { useExperiment } from "@catchoftheday/analytics";
import { Box, ContentPlaceHolder, Flex, IconCatchCLogo, IconClockTruck, IconToolTip, Link, Span, Text, Tooltip } from "@catchoftheday/cg-components";
import { TemplatedMessage } from "@catchoftheday/common-vendors";
import { styled } from "@catchoftheday/theme";
import { CATCH_SELLER_ID, PDP_DELIVERY_ESTIMATES_EXPERIMENT } from "@product-app/consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
var ZeroMarginOnLastChildBox = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & > *:last-child {\n    margin-bottom: 0;\n  }\n"])));
var mapDispatchType = {
  SPECIAL_ORDER: "Special Order",
  IN_STOCK: "In Stock",
  MARKETPLACE: "Marketplace"
};
export var ShippingInformation = function ShippingInformation(_ref) {
  var _ref$shipping = _ref.shipping,
      soldByCatch = _ref$shipping.soldByCatch,
      dispatchNotice = _ref$shipping.dispatchNotice,
      dropshipDisclaimer = _ref$shipping.dropshipDisclaimer,
      onePassDisclaimer = _ref$shipping.onePassDisclaimer,
      freeShippingDisclaimer = _ref$shipping.freeShippingDisclaimer,
      itemLocation = _ref$shipping.itemLocation,
      _ref$seller = _ref.seller,
      name = _ref$seller.name,
      slug = _ref$seller.slug,
      id = _ref$seller.id,
      purchaseLimit = _ref.purchaseLimit,
      offerId = _ref.offerId,
      freeShipping = _ref.freeShipping,
      isGiftCard = _ref.isGiftCard;

  var _useExperiment = useExperiment([PDP_DELIVERY_ESTIMATES_EXPERIMENT]),
      _useExperiment$varian = _slicedToArray(_useExperiment.variants, 1),
      experimentDeliveryEstimates = _useExperiment$varian[0],
      experimentDeliveryEstimatesLoading = _useExperiment.loading;

  var isDeliveryEstimatesExperiment = (experimentDeliveryEstimates === null || experimentDeliveryEstimates === void 0 ? void 0 : experimentDeliveryEstimates.bucket) === 1;

  if (experimentDeliveryEstimatesLoading) {
    return ___EmotionJSX(ContentPlaceHolder, {
      speed: 2,
      viewBox: "0 0 230 35",
      backgroundColor: "#f3f3f3",
      foregroundColor: "#ecebeb",
      "aria-label": "Loading"
    }, ___EmotionJSX("rect", {
      x: "0",
      y: "10",
      rx: "3",
      ry: "3",
      width: "100%",
      height: "10"
    }), ___EmotionJSX("rect", {
      x: "0",
      y: "25",
      rx: "3",
      ry: "3",
      width: "100%",
      height: "10"
    }));
  }

  return ___EmotionJSX(Flex, null, ___EmotionJSX(Box, {
    width: isDeliveryEstimatesExperiment && !soldByCatch ? "auto" : "50px",
    flex: "0 1 auto"
  }, soldByCatch ? ___EmotionJSX(IconCatchCLogo, {
    width: "37px",
    height: "auto",
    title: "Catch logo"
  }) : ___EmotionJSX(React.Fragment, null, !isDeliveryEstimatesExperiment && ___EmotionJSX(IconClockTruck, {
    width: "37px",
    height: "auto",
    title: "Delivery truck"
  }))), ___EmotionJSX(Box, {
    flex: "1"
  }, freeShipping && !isGiftCard && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Span, {
    color: "primary",
    fontWeight: "400",
    textTransform: "uppercase",
    mr: "5px"
  }, "Free Delivery"), freeShippingDisclaimer && ___EmotionJSX(Tooltip, {
    placement: "top",
    reference: ___EmotionJSX(IconToolTip, {
      width: "14px",
      height: "14px",
      mt: "-4px",
      color: "typography.subText"
    }),
    mb: isDeliveryEstimatesExperiment && !soldByCatch ? "10px" : null
  }, ___EmotionJSX(Text, {
    m: "0",
    fontSize: "xs"
  }, freeShippingDisclaimer))), ___EmotionJSX(Flex, {
    justifyContent: "space-between",
    alignItems: "flex-start"
  }, ___EmotionJSX(ZeroMarginOnLastChildBox, null, isDeliveryEstimatesExperiment ? ___EmotionJSX(React.Fragment, null, !soldByCatch && ___EmotionJSX(Span, {
    display: "inline-block",
    backgroundColor: "primary",
    color: "textWhite",
    fontSize: "xs",
    lineHeight: "12px",
    fontWeight: "medium",
    p: "4px 6px",
    mb: "5px"
  }, "Marketplace Seller")) : ___EmotionJSX(React.Fragment, null, itemLocation && id == CATCH_SELLER_ID && !isGiftCard && ___EmotionJSX(Text, {
    m: 0
  }, "Item location: ", ___EmotionJSX(Span, {
    fontWeight: "400"
  }, itemLocation)), dispatchNotice && !isGiftCard && ___EmotionJSX(Text, {
    m: 0
  }, "".concat(mapDispatchType[dispatchNotice.type], " - "), dispatchNotice.message)), !isGiftCard && ___EmotionJSX(Text, {
    m: 0,
    "data-testid": "sold-by"
  }, "Sold and delivered by", " ", slug ? ___EmotionJSX(Link, {
    href: "/seller/".concat(slug, "?oid=").concat(offerId, "#popular_products")
  }, name) : ___EmotionJSX(Span, {
    fontWeight: "400"
  }, name)), isGiftCard && ___EmotionJSX(Text, {
    mt: 0
  }, "The gift card will be sent to the recipient's email shortly after purchase!"), purchaseLimit && purchaseLimit > 0 && ___EmotionJSX(Text, {
    mt: 0
  }, "Limit per customer: ", purchaseLimit), dropshipDisclaimer && !isGiftCard && ___EmotionJSX(Text, {
    mt: "0"
  }, ___EmotionJSX(TemplatedMessage, {
    templateString: dropshipDisclaimer
  })), onePassDisclaimer && ___EmotionJSX(Text, {
    mt: "0"
  }, ___EmotionJSX(Span, {
    fontWeight: "400"
  }, "Please note:"), " ", ___EmotionJSX(TemplatedMessage, {
    templateString: onePassDisclaimer
  }))))));
};